import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

// Breadcrumb boleh dilihat, contoh: Home > Blog > Topik > Artikel
export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-5" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1 text-xs text-[#9CA3AF]">
        {items.map((it, i) => (
          <li key={it.label} className="flex items-center gap-1 min-w-0">
            {i > 0 && <ChevronRight className="h-3 w-3 shrink-0" />}
            {it.to ? <Link to={it.to} className="hover:text-[#9333EA] truncate max-w-[180px]">{it.label}</Link>
              : <span className="text-[#6B7280] truncate max-w-[220px]" aria-current="page">{it.label}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export const breadcrumbJsonLd = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem', position: i + 1, name: it.label, item: `https://flexaviral.com${it.to || it.path}`,
  })),
});
